<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/garage/index' }"
        >车库管理</el-breadcrumb-item
      >
      <el-breadcrumb-item>楼层管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="queryForm" :model="searchForm" inline>
      <el-form-item label="房号">
        <el-input
          v-model="searchForm.title"
          autocomplete="off"
          maxlength="30"
          placeholder="请输入"
          clearable
          size="mini"
        />
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input
          v-model="searchForm.mobile"
          autocomplete="off"
          maxlength="30"
          placeholder="请输入"
          clearable
          size="mini"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchChange"
          size="mini"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" @click="resets" size="mini"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      icon="el-icon-plus"
      plain
      @click="handleNewAdd"
      size="mini"
      style="margin-top: 2vh"
      >新增楼层</el-button
    >
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#F5F7FA',
        height: '70px',
        fontSize: '13px',
      }"
    >
      <el-table-column prop="title" label="楼层" align="center" />
      <el-table-column prop="status" label="拉黑" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success" size="mini"
            >发送</el-tag
          >
          <el-tag v-if="scope.row.status == 0" type="danger" size="mini"
            >拉黑</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="text"
            size="small"
            icon="el-icon-edit"
          >
            修改信息
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="text"
            size="small"
            icon="el-icon-delete"
          >
            移除房间
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.pageSize"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="楼层名称">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="业主名称">
              <el-input
                v-model="form.realname"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
      
      <script>
import { getroomList, editRoom, addRoom, deleteRoom } from "../../api/room";
import { getFloorList, addFloor } from "../../api/floor";
import tableCommon from "../../../mixins/table-common";
import { getCookie } from "../../utils/util";
export default {
  mixins: [tableCommon],
  data() {
    return {
      regionTypes: [
        {
          label: 1,
          text: "发送",
        },
        {
          label: 0,
          text: "拉黑",
        },
      ],
      api: {
        list: getFloorList,
        add: addFloor,
        edit: editRoom,
        del: deleteRoom,
      },

      // 导入导出弹窗
      importOpen: false,
      // 规则验证
      rules: {},
      // 传参
      form: {
        status: "1",
        building_id: "",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        pageSize: 15,
      },
      // 列表数据
      tableList: [],
      // 请求id
      id: "",
      // 分页
      total: 0,
      appOpen: false,
      // 小程序码
      appUrl: "",
      // 回传id
      lastId: "",
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 图片上传地址
      uploadImgUrl: process.env.VUE_APP_URL + "/admin/roomImport",
    };
  },
  mounted() {
    this.searchForm.carpark_id = this.$route.query.id;
    this.initList();
  },
  methods: {
    // 搜索重置
    resets() {
      this.searchForm = {
        title: undefined,
      };
      this.initList();
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.handleAdd();
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      const { city_name, created_at, share_img, ...rest } = row;
      this.form = rest;
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
    // 提交
    submitForms() {
      //   this.form.city_id = this.$route.query.id;
      this.form.carpark_id = this.$route.query.id;
      // this.form.city_id = this.$route.query.lastId;
      console.log(this.form);
      this.submitForm();
    },
  },
};
</script>
    <style scoped>
/deep/.el-form-item {
  margin: 2vh 0 0 0;
}
.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/garage/floor.vue